import React,{Component} from 'react';
import { TabBar,Button } from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css'; 
import 'antd-mobile/lib/date-picker/style'; 
import './App.css';
import { connect } from 'dva';
import Config from './config';
import Home from './components/Home';
import My from './components/My';
import {isWeiXin,appendParams,getUrlParams} from './utils/WeiXinTool';



class App extends Component {
 
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'TabBar1',
      hidden: false,
      fullScreen: true,
      code:''
    };
  }
  componentDidMount()
  { 
    
    if(!isWeiXin())
    {
      this.login();
     
    } else{
      this.weixinLogin();
    }
    
  }
  login()
  {
    if(!localStorage.getItem('AAC002'))
    {
      this.props.dispatch({type:"index/changeRouter",payload:{route:Config.loginMode}});
    }
    
  }
  weixinLogin() {
    if(!localStorage.getItem('openid'))
    {
      let code = getUrlParams('code');
    
      if(!code)
      {
        this.get_wxcode();
      }else{
        this.props.dispatch({type:"weixin/access_token",payload:{
          code:code
        }}).then(()=>{
          let {access_token,openid} = this.props;
          this.props.dispatch({type:"weixin/userinfo",payload:{
            access_token ,
            openid 
          }});

          this.props.dispatch({type:"weixin/getBindPhone",payload:{
             openid,
             appid:Config.appid
          }});

        });
      }
    }
  }

  get_wxcode()
  {
        let temp_code = getUrlParams('code');
        let redirectUrl;
        if (!temp_code) {
            redirectUrl = appendParams([{
                key: 'appid',
                value: Config.appid
            }, {
                key: 'redirect_uri',
                value: encodeURIComponent(window.location.href)
            }, {
                key: 'response_type',
                value: 'code'
            }, {
                key: 'scope',
                value: 'snsapi_userinfo'
            }, {
                key: 'state',
                value: 'xlcrk'
            }], 'http://hadeling.com/get-wxcode.html');
            window.location.href = redirectUrl;
        } else{
            this.setState({
              code:temp_code
              
            });
            
        }
        return temp_code;
  }

  test(){

  
    
  }

  renderContent(pageText) {
    return (
      <div style={{ backgroundColor: 'white', height: '100%', textAlign: 'center' }}>
      <img alt="touxiang" src={localStorage.getItem("headimgurl")} />
      <Button type="primary" size="small" onClick={e=>this.test()}>primary</Button>
      {pageText}

      </div>
    );
  }
  render() {
    return (
     
      <div className="fullScreen">
        <TabBar unselectedTintColor="#949494" tintColor="#33A3F4" barTintColor="white" hidden={this.state.hidden}>
          <TabBar.Item
            title="首页"
            key="Tab1"
            icon={<div className="iconTabBar1" />}
            selectedIcon={<div className="selectedIconTabBar1" />}
            selected={this.state.selectedTab === 'TabBar1'}
            badge={0}
            onPress={() => {this.setState({selectedTab: 'TabBar1',});}}
            data-seed="logId"
          >
            {/*this.renderContent('首页')*/}
            <Home/>
            
          </TabBar.Item>

          <TabBar.Item
            title="产品"
            key="Tab2"
            badge={0}
            icon={<div className="iconTabBar2" />}
            selectedIcon={<div className="selectedIconTabBar2" />}
            selected={this.state.selectedTab === 'TabBar2'}
            onPress={() => {this.setState({selectedTab: 'TabBar2',});}}
            data-seed="logId1"
          >
            {this.renderContent('产品: 努力开发中')}
          </TabBar.Item>

          <TabBar.Item
            
            title="购物车"
            key="Tab3"
            icon={<div className="iconTabBar3" />}
            selectedIcon={<div className="selectedIconTabBar3" />}
            selected={this.state.selectedTab === 'TabBar3'}
            onPress={() => {this.setState({selectedTab: 'TabBar3',});}}
          >
            {this.renderContent('购物车: 努力开发中')}
          </TabBar.Item>

          <TabBar.Item
            title="我的"
            key="Tab4"
            icon={<div className="iconTabBar4" />}
            selectedIcon={<div className="selectedIconTabBar4" />}
            selected={this.state.selectedTab === 'TabBar4'}
            onPress={() => {this.setState({selectedTab: 'TabBar4',});}}
          >
            <My/>
          </TabBar.Item>
        </TabBar>
      </div>
    );
  }
}

export default connect(state=>{
  return{
    ...state.weixin,
    loading: state.loading.global
  }
}
)(App);
